import { isVPCMode } from '@/lib/utils'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

const currentEnv = import.meta.env.VITE_ENVIRONMENT
const apiBaseUrlKey = ['api-base-url']

type ApiBaseUrlConfig = Record<typeof currentEnv, string>

function useApiBaseUrlQuery(options: Omit<UseQueryOptions<string>, 'queryKey' | 'queryFn'> = {}) {
  return useQuery({
    queryKey: apiBaseUrlKey,
    queryFn: async () => {
      const response = await fetch('/public/api-base.json', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) throw new Error('FAILED_TO_FETCH_API_URL_JSON')

      const data = (await response.json()) as ApiBaseUrlConfig

      if (isVPCMode) return data.vpc

      if (!currentEnv) throw new Error('FAILED_TO_GET_CURRENT_ENV')

      if (currentEnv === 'dev' || currentEnv === 'local') return data.dev
      if (currentEnv === 'stg') return data.stg
      if (currentEnv === 'prod') return data.prod

      throw new Error('FAILED_TO_GET_MATCHING_BASE_URL')
    },
    ...options,
  })
}

export { apiBaseUrlKey, useApiBaseUrlQuery }
